module.exports = __webpack_public_path__ + "img/preview.41a270d6.png";